module.exports = __webpack_public_path__ + "static/media/image.97ee6920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/SEOin2020/image.jpg
// module id = 463
// module chunks = 0